// extracted by mini-css-extract-plugin
export default {"info":"Info-module__[local]___9Wxhi","field":"Info-module__[local]___1QLiW","label":"Info-module__[local]___dYL64","value":"Info-module__[local]___E06N9"};